import React, { useEffect, useState } from "react";
import { Phone, Scale } from "lucide-react";
import ThemeToggle from "@/components/site/ThemeToggle";

const links = [
  { label: "Practice", href: "#practice" },
  { label: "About", href: "#about" },
  { label: "Of Counsel", href: "#of-counsel" },
  { label: "Contact", href: "#contact" },
];

export default function Nav({ theme, onToggleTheme }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled
          ? "bg-[#fdfbf7]/92 backdrop-blur-xl border-b border-[#bfa15f]/25"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20 flex items-center justify-between h-20 md:h-24">
        {/* Monogram */}
        <a
          href="#top"
          data-testid="nav-monogram"
          className="flex items-center gap-3 group"
        >
          <span className="relative inline-flex items-center justify-center w-11 h-11 border border-[#bfa15f] text-[#1a362d]">
            <Scale className="w-5 h-5" strokeWidth={1.4} />
            <span className="absolute -inset-[3px] border border-[#bfa15f]/35 pointer-events-none" />
          </span>
          <span className="hidden sm:flex flex-col leading-none">
            <span className="font-serif-display text-[1.15rem] text-[#0f172a] tracking-tight">
              Kinsi Bollinger
            </span>
            <span className="text-[0.62rem] uppercase tracking-[0.28em] text-[#475569] mt-1">
              Attorney at Law
            </span>
          </span>
        </a>

        {/* Center links */}
        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-[0.78rem] uppercase tracking-[0.22em] text-[#0f172a] hover:text-[#1a362d] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* Phone CTA + Theme toggle */}
        <div className="flex items-center">
          <ThemeToggle theme={theme} onToggle={onToggleTheme} />
          <a
            href="tel:8015024017"
            data-testid="nav-phone-cta"
            className="group flex items-center gap-2 md:gap-3 border border-[#1a362d]/80 px-3 md:px-5 py-2.5 hover:bg-[#1a362d] hover:text-[#fdfbf7] transition-colors"
          >
            <Phone className="w-3.5 h-3.5" strokeWidth={1.6} />
            <span className="text-[0.72rem] md:text-[0.78rem] uppercase tracking-[0.18em] font-medium">
              801.502.4017
            </span>
          </a>
        </div>
      </div>
    </header>
  );
}
